import React from 'react';
import { Typography, Breadcrumbs } from '@mui/material';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import FadeIn from 'react-fade-in';
import baseStyles from '../Common/styles';

import banner from '../assets_2026/seasonal_page_Q2_2026_banner.png';
import innerGlowImg from '../assets_2026/seasonal_page_Q2_2026_inner_glow_btn.png';
import highImpactImg from '../assets_2026/seasonal_page_Q2_2026_high_impact_btn.png';
import vibrantCodeImg from '../assets_2026/seasonal_page_Q2_2026_vibrant_code_btn.png';

const useStyles = makeStyles((theme) => ({
    ...baseStyles(theme),
    breadcrumbs: {
        margin: '20px 0',
    },
    bannerWrap: {
        position: 'relative',
        marginBottom: '30px',
    },
    banner: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    bannerOverlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '0 6.8%',
        color: '#fff',
        textTransform: 'uppercase',
        letterSpacing: '0.02em',
        fontSize: '2.75rem',
        fontWeight: 400,
        pointerEvents: 'none',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.4rem',
        },
    },
    bannerOverlayBold: {
        fontWeight: 700,
        marginRight: '0.4em',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0',
        marginBottom: '60px',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
    column: {
        borderRight: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('sm')]: {
            borderRight: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '&:last-child': {
            borderRight: 'none',
            [theme.breakpoints.down('sm')]: {
                borderBottom: 'none',
            },
        },
    },
    columnImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    columnText: {
        padding: '20px',
    },
    columnTitle: {
        fontWeight: 700,
        textTransform: 'uppercase',
        marginBottom: '10px',
    },
}));

const LINES = [
    {
        key: 'inner-glow',
        title: 'Inner Glow',
        image: innerGlowImg,
        description: 'Sensitivity and vulnerability are the new superpower. Inner Glow explores soft delicate details, airy volume and light filtering materials. Creating a world of ethereal strength.',
    },
    {
        key: 'high-impact',
        title: 'High Impact',
        image: highImpactImg,
        description: 'As consumers seek versatility in dress, High Impact captures the intersection of minimalism and functionality. Creating an adaptive sport aesthetic through rich neutrals and high visibility details.',
    },
    {
        key: 'vibrant-code',
        title: 'Vibrant Code',
        image: vibrantCodeImg,
        description: 'Fueled by the desire for lightness and joy, performance materials are drenched in bright colors and playful blocking. Vibrant Code brings layers of optimism to sport and outdoor exploration.',
    },
];

export default function Q2Collection2026() {
    const classes = useStyles();

    return (
        <FadeIn>
            <div className={classes.root}>
                <Breadcrumbs className={classes.breadcrumbs} aria-label="breadcrumb">
                    <Link color="inherit" component={RouterLink} to="/">JML Home</Link>
                    <Link color="inherit" component={RouterLink} to="/seasonal-collection">Seasonal Collection</Link>
                    <Link color="inherit" component={RouterLink} to="/seasonal-collection/2026">2026 Seasonal Collection</Link>
                    <Typography color="primary">Q2 2026</Typography>
                </Breadcrumbs>

                <div className={classes.bannerWrap}>
                    <img src={banner} alt="Q2 2026 Collection" className={classes.banner} />
                    <Typography component="div" className={classes.bannerOverlay}>
                        <span className={classes.bannerOverlayBold}>Q2 2026</span>Collection
                    </Typography>
                </div>

                <div className={classes.grid}>
                    {LINES.map((line) => (
                        <div key={line.key} className={classes.column}>
                            <img src={line.image} alt={line.title} className={classes.columnImage} />
                            <div className={classes.columnText}>
                                <Typography variant="subtitle1" className={classes.columnTitle}>{line.title}</Typography>
                                <Typography variant="body2">{line.description}</Typography>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </FadeIn>
    );
}
